import dayjs from 'dayjs';
import {ReactNode} from 'react';

import {ActivationBanner} from '../../../../layout/activation-page/activation-banner';
import {Spinner} from '../../../../layout/spinner/spinner';
import {useNotificationsLicenses} from '../../../../service/notifications-settings/notifications-licenses';
import {useTariffs} from '../../../../service/tariffs/tariffs-user-tariffs';

type PropsType = {
    children: ReactNode;
    type: string;
};

export function NotificationTabWrapper(props: PropsType): JSX.Element {
    const {children, type} = props;

    const {data: tariffs} = useTariffs();
    const today = dayjs();

    const tariffId = tariffs?.results?.[0]?.id;

    const {data: notificationLicenses, isFetching} = useNotificationsLicenses(tariffId);

    const hasLicense =
        notificationLicenses?.activeTrialLicences?.find(
            (license) =>
                license.types?.includes(type) &&
                dayjs(license.startAt).isSameOrBefore(today, 'day') &&
                dayjs(license.finishAt).isSameOrAfter(today, 'day')
        ) ||
        notificationLicenses?.paidLicences?.find(
            (license) =>
                license.types?.includes(type) &&
                dayjs(license.startAt).isSameOrBefore(today, 'day') &&
                dayjs(license.finishAt).isSameOrAfter(today, 'day')
        );

    if (isFetching) {
        return <Spinner wrapperHeight={400} />;
    }

    if (!hasLicense) {
        return <ActivationBanner />;
    }

    return <div>{children}</div>;
}
